// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Modal = require('client-v2/common/components/modal')

// BEM Block entity definition

const bem = BemEntity('ConfirmModal')

function ConfirmModal({
  buttons,
  className,
  dismissOnBackdropClick,
  hasBackdrop,
  hasCloseButton,
  heading,
  subheading,
  onConfirm
}) {
  const onDismiss = React.useCallback(
    () => { onConfirm() },
    [ onConfirm ]
  )
  return (
    tag(Modal, {
      className: classNames(
        className,
        bem.block()
      ),
      dismissOnBackdropClick,
      hasBackdrop,
      hasCloseButton,
      onDismiss
    },
      !!heading && tag('div', {
        className: bem.element('heading')
      },
        heading
      ),
      !!subheading && tag('div', {
        className: bem.element('subheading')
      },
        subheading
      ),
      tag('div', {
        className: bem.element('buttons')
      },
        buttons.map(buttonProps => (
          tag(ConfirmModalButton, {
            ...buttonProps,
            key: `button:${buttonProps.label}`,
            onConfirm
          })
        ))
      )
    )
  )
}

const buttonPropTypes = {
  className: PropTypes.string,
  modifiers: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool)
  ]),
  label: PropTypes.string.isRequired,
  value: PropTypes.any
}

ConfirmModal.propTypes = {
  // Flags
  dismissOnBackdropClick: PropTypes.bool,
  hasBackdrop: PropTypes.bool,
  hasCloseButton: PropTypes.bool,
  // Values
  buttons: PropTypes.arrayOf(
    PropTypes.shape(buttonPropTypes)
  ).isRequired,
  className: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  // Callbacks
  onConfirm: PropTypes.func.isRequired
}

ConfirmModal.defaultProps = {
  dismissOnBackdropClick: false,
  hasBackdrop: true,
  hasCloseButton: false
}

module.exports = ConfirmModal

// BEM Block entity Element components

function ConfirmModalButton(props) {
  const onClick = React.useCallback(
    () => { props.onConfirm(props.value) },
    [ props.onConfirm, props.value ]
  )
  return (
    tag('button', {
      className: classNames(
        props.className,
        bem.element('button', props.modifiers)
      ),
      onClick
    },
      props.label
    )
  )
}

ConfirmModalButton.propTypes = {
  ...buttonPropTypes,
  onConfirm: PropTypes.func.isRequired
}
